import type React from 'react';

import type { UserRecord } from '@vlabs/api/artemy/model';

import type { BuildTableViewCellProps, TableCtx, TBuildTableViewCell } from '@vlabs/monokit/shared/ui/table-view';
import {
  buildTableViewCell,
  getTestIdFromTableCtx,
} from '@vlabs/monokit/shared/ui/table-view';

type TSharedCtx = TableCtx<UserRecord, React.ReactNode>;
const getUserRowTestId = (user: UserRecord): string => user.user_id;

export { renderHeader, renderCell } from '@vlabs/monokit/shared/ui/table-view';

function createUserCell(
  props: BuildTableViewCellProps,
): (ctx: TSharedCtx | undefined) => TBuildTableViewCell {
  return (ctx) => buildTableViewCell({
    ...props,
    ...getTestIdFromTableCtx(ctx, getUserRowTestId),
  });
}

export const statusCell = createUserCell({
  style: { flex: '1 0 0', minWidth: 0 },
});

export const fullNameCell = createUserCell({
  style: { flex: '1 0 0', minWidth: 0 },
});

export const emailCell = createUserCell({
  style: { flex: '1 0 0', minWidth: 0 },
});

export const roleCell = createUserCell({
  style: { flex: '1 0 0', minWidth: 0 },
});

export const lastLoginAtCell = createUserCell({
  style: { flex: '1 0 0', minWidth: 0 },
});

export const departmentsCell = createUserCell({
  style: { flex: '1 0 0', minWidth: 0 },
});

export const actionCell = createUserCell({
  style: {
    flex: '0 0 40px',
    padding: 0,
  },
});

export const dividerCell = buildTableViewCell({
  style: {
    flex: '0 0 16px',
    padding: 0,
  },
});
